import {combineReducers, AnyAction, Reducer} from '@reduxjs/toolkit'
import {userReducerName, TUserActions} from 'features/User'
import {settingsReducerName, TSettingsActions} from 'features/Settings'

import {adminReducerName, TAdminActions} from 'features/Admin'
import {
  endpointsReducerName,
  TEndpointsActions,
} from 'features/Endpoints/endpointsSlice'
import {
  analyticsShadowITReducerName,
  TAnalyticsShadowITActions,
} from 'features/Analytics/ShadowIT/analyticsShadowITSlice'

import {
  analyticsTopCategoriesReducerName,
  analyticsActivityByTimeReducerName,
  TAnalyticsProductivityActions,
  productivitySearchInputsReducerName,
  topCategoriesTimeStampReducerName,
} from 'features/Analytics/Productivity/analyticsProductivitySlice'

import {
  policiesReducerName,
  TPoliciesActions,
} from 'features/Policies/policiesSlice'
import {
  analyticPolicyTopBlocksReducerName,
  TAnalyticsPolicyActions,
} from 'features/Analytics/Policy/analyticsPolicySlice'

import {
  overviewAnalyticsReducerName,
  overviewViolationsReducerName,
  TAnalyticsOverviewActions,
} from 'features/Analytics/Overview/analyticsOverviewSlice'
import {
  analyticDetailReducerName,
  TAnalyticsDetailActions,
} from 'features/Analytics/Detail/analyticsDetailSlice'
import {analyticsLogsDownloadReducerName} from 'features/Analytics/Downloads/AnalyticsLogs/slice'
import {violationsLogsDownloadReducerName} from 'features/Analytics/Downloads/ViolationsLogs/slice'
import {appReducers} from './appReducers'

const appReducer = combineReducers(appReducers)

export type iRootState = ReturnType<typeof appReducer>

const rootReducer: Reducer = (state: iRootState, action: AnyAction) => {
  if (action.type === 'reset/store') {
    state = {} as iRootState
  }
  return appReducer(state, action)
}

export type AppActions =
  | TUserActions
  | TSettingsActions
  | TAdminActions
  | TEndpointsActions
  | TPoliciesActions
  | TAnalyticsShadowITActions
  | TAnalyticsProductivityActions
  | TAnalyticsPolicyActions
  | TAnalyticsOverviewActions
  | TAnalyticsDetailActions

export type StateSlices =
  | typeof userReducerName
  | typeof settingsReducerName
  | typeof adminReducerName
  | typeof endpointsReducerName
  | typeof policiesReducerName
  | typeof analyticsShadowITReducerName
  | typeof analyticsTopCategoriesReducerName
  | typeof analyticsActivityByTimeReducerName
  | typeof analyticPolicyTopBlocksReducerName
  | typeof overviewViolationsReducerName
  | typeof overviewAnalyticsReducerName
  | typeof analyticDetailReducerName
  | typeof analyticsLogsDownloadReducerName
  | typeof violationsLogsDownloadReducerName
  | typeof productivitySearchInputsReducerName
  | typeof topCategoriesTimeStampReducerName

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
